module.exports = __webpack_public_path__ + "assets/images/marker-icon.png";


//////////////////
// WEBPACK FOOTER
// ./~/leaflet/dist/images/marker-icon.png
// module id = 1533
// module chunks = 1